import { render, staticRenderFns } from "./OldCheckboxGroupAll.vue?vue&type=template&id=6a648426&"
import script from "./OldCheckboxGroupAll.vue?vue&type=script&lang=js&"
export * from "./OldCheckboxGroupAll.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports